import { LegendServiceType } from 'legends/PublishedLegend'
import { match } from '../../utils/pattern-match-util'
import { ServiceTypeResource } from './legend'

export function mapServiceTypeResourceToServiceType(
  serviceType: ServiceTypeResource,
): LegendServiceType {
  return match(serviceType, {
    TAX: () => LegendServiceType.Tax,
    MISC: () => LegendServiceType.Misc,
    BOOKKEEPING: () => LegendServiceType.Bookkeeping,
    CONSULTATION: () => LegendServiceType.Consultation,
  })
}
